import { FunctionComponent, useEffect, useState } from "react";
import SortIcon, { SortIconState } from "../../layout/icons/SortIcon";
import HanTableCell from "../../utils/han-table-components/HanTableCell";
import HanTableRow from "../../utils/han-table-components/HanTableRow";

export interface SortableTableHeadCell {
  name: string,
  orderByName: string,
}

interface Props {
  cells: SortableTableHeadCell[],
  onOrderBy: (orderBy: string, direction: string) => void
}

const SortableTableHead: FunctionComponent<Props> = ({cells, onOrderBy}) => {
  const [sortingState, setSortingState] = useState<SortIconState>(SortIconState.Initial);
  const [sortingHeaderCell, setSortingHeaderCell] = useState<SortableTableHeadCell>();

  useEffect(() => {
    if(sortingState === SortIconState.Initial) {
        return;
    }

    onOrderBy(sortingHeaderCell?.orderByName || "", sortingState.toString());
  }, [sortingState, onOrderBy, sortingHeaderCell?.orderByName]);

  const onHeaderCellClicked = (cell: SortableTableHeadCell) => {    
    setSortingHeaderCell(cell);

    if(sortingState === SortIconState.Initial) {
        setSortingState(SortIconState.Down);
    } else if(sortingState === SortIconState.Down) {
        setSortingState(SortIconState.Up);
    } else if(sortingState === SortIconState.Up) {
        setSortingState(SortIconState.Down);
    }
  }

  return (
    <HanTableRow modifiers={['sortable-head']}>
        { cells.map((cell, index) => (
            <HanTableCell modifiers={['black']} key={index} onClick={() => onHeaderCellClicked(cell)}>
                    {cell.name} <SortIcon className="han-table__row--sortable-head__icon" state={sortingHeaderCell?.orderByName === cell.orderByName ? sortingState : SortIconState.Initial} />
            </HanTableCell>
        )) }
    </HanTableRow>
  );
};


export default SortableTableHead;